export default __webpack_public_path__ + "static/media/pickup.74afe1e2.png";